export default "__VITE_ASSET__CX2GhOWp__"